
<template>

  <div class="fixed-tabs grey-back full-height">
  <!-- <v-btn color="success" @click="fn_debug"></v-btn> -->

    <!-- <div @click="fn_openGreeting" style="background: #ffd54a;border-bottom: 0.5px #4b77be dotted;">
      <v-subheader style="color: #ff6b00;" subheader-semi-dense>

          ✨ Diwali Wishes 🪔
        <v-spacer></v-spacer>
        <v-icon color="primary" font20 class="ml-1">chevron_right</v-icon>
      </v-subheader>
    </div> -->

    <!-- <div class="banner" id="banner" @click="fn_openGreeting">
    🎉 Special Diwali Greeting! <span>Open</span>
  </div> -->

    <!-- <v-btn color="success" @click="fn_openGreeting">text</v-btn> -->
    <!-- <v-btn color="success" @click="$root.fn_driveError('', 'User not login to drive')">text</v-btn> -->

    <!-- <v-subheader v-if="$root.CurrentBusiness && !$root.CurrentBusiness.DataDrive" subheader-semi-dense norightpadding grey-back @click="fn_setDataDrive">Setup Backup Drive
      <v-spacer></v-spacer>
      <v-btn color="primary" flat>Setup Now</v-btn>
    </v-subheader> -->

    <!-- <div white-background style="position: sticky;top: 56px;z-index: 1;" v-if="$root.CurrentBusiness && !$root.CurrentBusiness.DataDrive">
      <v-subheader class="video-link-tile" subheader-semi-dense norightpadding grey-back @click="fn_setDataDrive"><v-icon font20 class="mr-2">error_outline</v-icon> Set Auto Data Backup
        <v-spacer></v-spacer>
        <v-btn capitalize small style="border-radius: 5px;" color="primary" flat>Setup Now</v-btn>
      </v-subheader>
    </div> -->

    <!-- <v-alert :value="true" color="info" transition="slide-y-transition" v-if="$root.unsyncedItemsCount">
      {{$root.unsyncedItemsCount}} Unsynced Item(s)
    </v-alert> -->

    <!-- <v-btn color="success" @click="$root.fn_driveError('kjsdks', 'skjdsk User not login to drive jksdshds')">text</v-btn> -->
    <v-toolbar fixed tabs dense flat>
      <v-tabs v-model="activeIndex" @input="fn_tabChange" slider-color="primary">
        <v-tab v-for="(tab, index) in tabs" :key="index" ripple>{{tab.title}}</v-tab>
      </v-tabs>
    </v-toolbar>
    
    <v-tabs-items v-model="activeIndex" @input="fn_tabChange">

      <v-tab-item grey-back>  
        <keep-alive>
          <favourites :showInvoiceCard="showInvoiceCard" :openHelpSheet="fn_openHelpSheet" ref="ref_favourites"></favourites>
        </keep-alive>
      </v-tab-item>

      <v-tab-item>  
        <keep-alive>
          <masters ref="ref_masters"></masters>
        </keep-alive>
      </v-tab-item>

      <v-tab-item>  
        <keep-alive>
          <transactions ref="ref_transactions"></transactions>
        </keep-alive>
      </v-tab-item>

    </v-tabs-items>

    <!-- <v-btn color="success" @click="fn_checkRunningCustomer">text</v-btn> -->

    <!-- <v-btn @click="fn_openHelpSheet" capitalize small color="primary" class="pr-2 pl-2" style="border-radius: 5px;color: rgba(255,255,255,0.72);position: fixed;bottom: 16px;margin: auto;right: 0;left: 0;width: fit-content;">
      <img width="20" class="mr-1" src="../../assets/icon_contact_support_white.svg" alt="contact_support"/>
      Need Help?
    </v-btn> -->

    <v-bottom-sheet v-model="helpsheet" v-if="helpsheet">
      <v-list nopadding margin-top-ten>
            <v-subheader subheader-semi-dense norightpadding>Need Help? <v-spacer></v-spacer> <v-btn icon @click="helpsheet = false;"><v-icon font20>close</v-icon></v-btn></v-subheader>
            <v-list-tile @click="fn_action('video')">
                <v-list-tile-action>
                  <v-icon class="primary-color">help_outline</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Watch Help Videos</v-list-tile-title>
                </v-list-tile-content>

            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile @click="fn_action('chat')">
                <v-list-tile-action>
                    <v-icon class="primary-color">chat</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Chat with us</v-list-tile-title>
                </v-list-tile-content>

            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile @click="fn_action('call')">
                <v-list-tile-action>
                    <v-icon class="primary-color">phone_in_talk</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Talk to us</v-list-tile-title>
                </v-list-tile-content>

            </v-list-tile>
          </v-list>
    </v-bottom-sheet>

    <!-- <v-bottom-sheet v-model="backupAlertSheet" v-if="backupAlertSheet">
      <v-card>
        <v-card-title class="title noshadow redcolor font18">
          <v-icon class="redcolor mr-3">warning</v-icon>Set Auto Data Backup Now
        </v-card-title>
	      <v-card-text class="pt-2 font16">
          <ul style="line-height: 32px;list-style-type: '\2713   ';">
            <li>Your data will be <span greencolor font-medium>Safe</span> and <span greencolor font-medium>Secure</span>.</li>
            <li>Keep it on your <span primary-color font-medium>Personal</span> email drive.</li>
            <li>Data will be backed up <span greencolor font-medium>Automatically</span>.</li>
            <li>No <span style="color: #fb8c00;" font-medium>Manual</span> backups required.</li>
            <li><span primary-color font-medium>Restore</span> from your email drive anytime.</li>
          </ul>
	      </v-card-text>
	      <v-card-actions style="padding:6px 0px;">
				  <v-layout row wrap>

            <v-flex xs12 sm12 md12 center-align pl-3 pr-3>
	        			<v-btn font-heavy color="primary" block @click="fn_gotoSetupDrive">Setup Now</v-btn>
	        		</v-flex>

              <v-flex xs12 sm12 md12 center-align pl-3 pr-3 mt-3>
	        			<v-btn font-heavy light-opacity-color flat block @click="fn_closeBackupAlert">Skip</v-btn>
	        		</v-flex>
	        	</v-layout>
		    </v-card-actions>
	      </v-card>
    </v-bottom-sheet> -->

    <dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_gotoSetupDrive" :skipAlert="fn_closeBackupAlert" :transactionCount="transactionCount"></dialog-drive-alert>

    <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :okBtnText="okBtnText" :cancelBtnText="cancelBtnText" :actionMethod="actionMethod" :cancelMethod="fn_closeDialogConfirmation"></dialog-confirmation>

    <!-- <dialog-diwali-greeting ref="ref_dialogDiwaliGreeting"></dialog-diwali-greeting> -->
    <!-- <dialog-backup-alert ref="ref_dialogBackupAlert" :gotoDataBackup="fn_gotoDataBackup"></dialog-backup-alert> -->
    <!-- <v-btn color="primary" flat to="/settings/appupdate">Test</v-btn> -->

    <!-- <dialog-add-favourites ref="ref_dialoagAddFavourites" :closeDialogFavourites="fn_closeDialogFavourites"></dialog-add-favourites> -->

  </div>
</template>

<script>

// import { table }  from 'table';
// const { table } = require('table');

const navigationMenu = require('../../config.js').configs.bottomNavigation;
let actionTabConfigs = require('../../config.js').configs.actionTabConfigs;

import transactions from './contents/transactions'
import masters from './contents/masters'
import favourites from './contents/favourites'
// import dialogAddFavourites from './dialog_add_favourites'

import dialogConfirmation from '../dialogs/dialog_confirmation'
import dialogDriveAlert from '../dialogs/dialog_drive_alert'
// import dialogDiwaliGreeting from '../dialogs/dialog_diwali_greeting'
// import dialogBackupAlert from '../dialogs/dialog_backup_alert'

// import VueApexCharts from 'vue-apexcharts'

let tagId = 'actions'

  export default {
    components:{
      "transactions": transactions,
      "masters": masters,
      "favourites": favourites,
      "dialog-confirmation":dialogConfirmation,
      "dialog-drive-alert":dialogDriveAlert,
      // "dialog-diwali-greeting":dialogDiwaliGreeting
      // "dialog-backup-alert":dialogBackupAlert
      // "dialog-add-favourites":dialogAddFavourites
      // 'apexchart': VueApexCharts
    },
    watch:{
      '$root.selectedLanguage': function(){
        if(this.$root.CurrentBusiness && this.$root.CurrentBusiness.BusinessID){
          this.fn_setBottomNavigation();
        }
      },
			'helpsheet': {
          handler: function (newVal, oldVal){
            // this.fn_saveToLocalStorage(this);
            if(newVal === false){
              this.fn_closeHelpSheet();
            }
          }
      }
		},
    data () {
      return {
        tabs:[
              {"id":"tab1", "title":"Favourites"},
              {"id":"tab2", "title":"Masters"},
              {"id":"tab3", "title":"Transactions"}
        ],
        currentTabComponent:null,
        activeIndex: null,
        groupNumber:1,
        dataVersionNumber:1,
        showInvoiceCard:null,
        helpsheet:false,
        transactionCount:null,
        confirmationHeader:null,
        confirmationMessage:null,
        okBtnText:null,
        cancelBtnText:null,
        actionMethod:null
        // backupAlertSheet:false

        // series:[5000.3433443, 4000.433],
        // accountBalanceData: {
        //       chart: {
        //         width: 380,
        //         type: 'pie',
        //       },
        //       labels: ['Team A', 'Team B'],
        //       responsive: [{
        //         breakpoint: 480,
        //         options: {
        //           chart: {
        //             width: 200
        //           },
        //           legend: {
        //             position: 'bottom'
        //           }
        //         }
        //       }]
        //   },

        // accountBalanceData:{
        //   options:{
        //     plotOptions: {
        //             bar:{
        //               horizontal: true,
        //       }
        //         },
        //     yaxis: {categories: ["Cash A/c"]},
        //     xaxis:{
        //       labels:{  
        //         formatter: function (val) {
        //             return val.toLocaleString("hi-IN");
        //           }
        //       }
        //     },
        //         fill:{type:"gradient"},
        //         labels: ["Cash A/c"],
        //         chart:{toolbar:{show:false}},
        //         dataLabels:{
        //           enabled: false
        //         }
        //   },
        //   series:[{
        //     name: 'Account Balance',
        //         data: [-5000]
        //   }]
        // },
      }
    },
    methods: {

      // fn_openGreeting: function(){
      //   window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
      //   window.js_globals.fn_onBackPress = this.fn_closeGreeting;
      //   this.fn_hideBottomNavigation();
      //   this.$refs['ref_dialogDiwaliGreeting'].openDialogWeb();
      // },

      // fn_closeGreeting: function(){
      //   localStorage.setItem('diwali_greeting', 1);
      //   window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
      //   this.fn_showBottomNavigation();
      //   this.$refs['ref_dialogDiwaliGreeting'].closeDialogWeb();
      // },

      fn_openBackupAlertSheet: function(){
        if(this.transactionCount < 10){
          window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
          window.js_globals.fn_onBackPress = this.fn_closeBackupAlert;
        }
        
        this.fn_hideBottomNavigation();
        // this.backupAlertSheet = true;
        this.$refs['ref_dialogDriveAlert'].openDialogWeb();
        // this.$refs['ref_dialoagAddFavourites'].openDialogWeb();
      },

      // fn_openDataBackupAlertSheet: function(){
      //   window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
      //   window.js_globals.fn_onBackPress = this.exitApp;
      //   this.fn_hideBottomNavigation();
      //   this.$refs['ref_dialogBackupAlert'].openDialogWeb();
      // },

      fn_closeBackupAlert: function(){
        window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
        this.fn_showBottomNavigation();
        // this.backupAlertSheet = false;
        this.$refs['ref_dialogDriveAlert'].closeDialogWeb();

        this.confirmationHeader = "Skip Auto Data Backup?";
        this.confirmationMessage = "<div class='pl-3 pr-3 pt-2 pb-2 mb-2' style='background:#fff3cd;color:#856404;margin:0px -16px;'><p class='mb-1 font16 font-medium'>Warning: You could lose your data, if you didn’t configure auto backup and changed device.</p></div><p class='mb-1 font16'>Are you sure you want to skip auto data backup?</p>"
        this.okBtnText = 'Setup Now';
        this.cancelBtnText = 'Yes';
        this.actionMethod = this.fn_gotoSetupDrive;

        this.fn_openDialogConfirmation();
      },

      fn_openDialogConfirmation: function(){
        window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
        window.js_globals.fn_onBackPress = this.fn_closeDialogConfirmation;
        this.$refs['ref_dialogConfirmation'].openDialogWeb();
      },

      fn_closeDialogConfirmation: function(){
        window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
        this.$refs['ref_dialogConfirmation'].closeDialogWeb();
        // if(!localStorage.getItem('diwali_greeting')){
        //   this.fn_openGreeting();
        // }
      },

      fn_gotoSetupDrive: function(){
        window.js_globals.fn_onBackPress = this.exitApp;
        this.$router.push({path:"/registration/business/setupdrive"});
      },

      fn_gotoDataBackup: function(){
        window.js_globals.fn_onBackPress = this.exitApp;
        this.$router.push({path:"/settings/backup", query:{exitapp:1}});
      },

      fn_differenceOfDays: function(){
          let businessCreatedDays = new Date(this.$root.CurrentBusiness.CreatedOn);
          let dateNow = new Date();
          return parseInt((dateNow - businessCreatedDays) / (1000 * 60 * 60 * 24), 10); 
      },

      fn_action: function(type){
        // this.fn_closeHelpSheet();
        this.helpsheet = false;
        if(type == 'video'){
          this.$root.fn_openExternalUrl('https://www.youtube.com/@BizOpsApp/videos');
        }
        else if(type == 'chat'){
          this.$root.fn_openExternalUrl("https://api.whatsapp.com/send?phone=918882741212");
        }
        else if(type == 'call'){
          this.$root.fn_openExternalUrl("https://api.whatsapp.com/send?phone=918882741212&text=Call me back");
        }
      },

      fn_openHelpSheet: function(){
        window.js_globals.fn_onBackPressPrevious = window.js_globals.fn_onBackPress;
        window.js_globals.fn_onBackPress = this.fn_closeHelpSheet;
        this.fn_hideBottomNavigation();
        this.helpsheet = true;
        // this.$refs['ref_dialoagAddFavourites'].openDialogWeb();
      },

      fn_closeHelpSheet: function(){
        window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
        this.fn_showBottomNavigation();
        this.helpsheet = false;
        // this.$refs['ref_dialoagAddFavourites'].closeDialogWeb();
      },

      test: function(){
        this.$router.push({
            name: 'subreport',
            params: {
                userData: {
                    "a": "b"
                }
            }
        })
      },

      print: function(){
        window.print();
      },

      // fn_setDataDrive: function(){
      //   if(!navigator.onLine){
      //     this.showToast("Internet not available");
      //     return;
      //   }

      //   this.$router.push({path:"/registration/business/setupdrive"});
      // },

      // fn_draftCount: function(){
      //   let self = this;
      //   this.getData('DraftCount', null, 
      //     {
      //       onSuccess: function(response){
      //         console.log(response);
      //         self.draftCount = JSON.parse(response);
      //       },
      //       onError: function(error){
      //           console.log(error);
      //       }
      //     }
      //   );
      // },

      fn_tabChange: function (tabIndex, tabChange) {
        console.log('in');
        // let self = this;
        actionTabConfigs.activeIndex = tabIndex;
        window.scroll(0,0);

        if(this.$root.appVersion < 253){
          if(tabIndex == 2){
            let saleIndex = this.$refs['ref_transactions'].listCategories[0].items.findIndex(item=>{return item.title == 'Credit Note'});
            if(saleIndex != -1){
              this.$refs['ref_transactions'].listCategories[0].items.splice(saleIndex, 1);
            }

            let purchaseIndex = this.$refs['ref_transactions'].listCategories[1].items.findIndex(item=>{return item.title == 'Debit Note'});
            if(purchaseIndex != -1){
              this.$refs['ref_transactions'].listCategories[1].items.splice(purchaseIndex, 1);
            }
          }
          else if(tabIndex == 1){
            let masterServiceAccountIndex = this.$refs['ref_masters'].listCategories[3].items.findIndex(item=>{return item.title == 'Service Account Item'});
            if(masterServiceAccountIndex != -1){
              this.$refs['ref_masters'].listCategories[3].items.splice(masterServiceAccountIndex, 1);
            }
          }
        }

        if(!tabChange){
          this.fn_removeMasterAndTransactions();
        }
        
        // tabIndex==0 ? this.fn_draftCount() : '';
      },

      fn_setBottomNavigation : function () {

          console.log('set navigation');

          let self = this;

          let viewObject = {}

          viewObject.NavigationMenu = navigationMenu.map(item => Object.assign({}, item, { Text: this.$t('actions.bottomNav.' + item.Text.toLowerCase()) }));

          this.setBottomNavigation(tagId, viewObject, 
              {
                onSuccess: function (response) {
                  console.log(response);
                  localStorage.setItem('bottomNavigationSet', 1);
                  // setTimeout(() => {
                  //   self.fn_checkPlayStoreUpdate();
                  // }, 1000);

                  self.fn_showBottomNavigation();
                },
                onError: function (error) {
                  console.log(error);
                }
              }
          )
      },

      fn_showBottomNavigation: function () {

        let self = this;

        let navigationObject = {activeIndex: 1003};

        this.showBottomNavigation(tagId, navigationObject, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
            // onChange: null, 
            onMenuItemClick: function (tagId, menuId, menuAction) {
              self.$root.fn_bottomNavigationItemClick(tagId, menuId, menuAction)
            }
          }
        );
      },

      fn_hideBottomNavigation: function () {

        this.hideBottomNavigation({
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }
          }
        );
        
      },

      fn_showWebView: function () {
        this.showWebView(tagId, {}, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
          }
        );
      },

      // jtcd = jump to connection details
      fn_initActions: function(isDbOpen, jtcd, isNotification){
        console.log("Init actions");
        console.log(isDbOpen);
        console.log(jtcd);
        console.log("notification " + isNotification ? 'yes' : 'no');

        // loading locale
        this.$root.fn_loadLocale();
        
        if(JSON.parse(isDbOpen)){
          this.fn_loadBusiness(jtcd, isNotification);
        }
        else{
          this.fn_openDatabase(jtcd, isNotification);
        }
      },

      fn_openDatabase: function(jtcd, isNotification){
        console.log("open database");
        let self = this;
        this.getData('OpenDatabase', null, 
        {
          onSuccess: function(response){
              console.log(response);
              self.fn_loadBusiness(jtcd, isNotification);
            }, 
            onError: function(error){
              console.log(error);
              self.showToast('Something went wrong. Try again');
            }
        });
      },

      fn_loadBusiness: function(jtcd, isNotification){
        console.log("load business");
        let self = this;
        this.$root.fn_getBusiness('actions', null, function(){

          // AndroidRoutingTest.onPageLoadCompleted('1', JSON.stringify({}));

          // if(self.$root.CurrentBusiness.IsAccountantOnly){
          //   self.$router.replace('/settings');
          // }
          // else{
          //   let bottomNavigationSet = Number(localStorage.getItem('bottomNavigationSet'));
          //   console.log(bottomNavigationSet);

          //   if(!bottomNavigationSet){
          //     self.fn_setBottomNavigation();
          //   }
          //   else{
          //     self.fn_showBottomNavigation();
          //   }  
          // }

          self.fn_getAndroidAppVer(jtcd, isNotification);

        });
        
      },

        // puran is calling this fn when deactivating a business and registering another
      fn_checkIsWebViewLoaded: function(){
        console.log("Web view loaded");
        AndroidRoutingTest.mainAppLoaded();
      },

      fn_removeLocalStorage: function(){
        localStorage.removeItem('transaction_filter');
        localStorage.removeItem('item_filter');
        localStorage.removeItem('activity_items_state');
        localStorage.removeItem('ledgers_items_state');
        localStorage.removeItem('transaction_items_state');
        localStorage.removeItem('scroll_top');
        localStorage.removeItem('activity_party_filter');
        localStorage.removeItem('activity_item_filter');
        localStorage.removeItem('activity_transaction_filter');
      },

      fn_getAndroidAppVer: function(jtcd, isNotification){
        let self = this;
        this.getData('AndroidAppVersion', null, 
          {
              onSuccess: function(response){
                console.log(response);
                let oldAppVersion = localStorage.getItem('appversion') ? Number(localStorage.getItem('appversion')) : 1;
                let newAppVersion = Number(response);
                self.$root.appVersion = Number(response);

                if(self.$root.appVersion < 331){
                  self.$root.isAppUpdateAvailable = true;
                }
                // saving android version number to android cache // using in desktop app
                self.$root.fn_saveLocalData({LocalKey:'app_version',LocalValue:newAppVersion});

                console.log('dataversion' + self.dataVersionNumber);
                if(oldAppVersion < newAppVersion){
                  self.dataVersionNumber = oldAppVersion + 1;
                  self.fn_processMigrationData(newAppVersion, jtcd, isNotification);
                }
                else{
                  // save version number to cache
                  // localStorage.setItem('appversion', newAppVersion);
                  self.fn_pageLoadComplete(newAppVersion, jtcd, isNotification);
                  // AndroidRoutingTest.onPageLoadCompleted('1', JSON.stringify({}));
                }
              }, 
              onError: function(error){
                console.log(error);
              }
          }
        );
      },

      fn_processMigrationData: function(newAppVersion, jtcd, isNotification){
        // let appVer = oldAppVersion ? oldAppVersion : Number(newAppVersion);
        console.log('dataversion '+this.dataVersionNumber);
        if(this.dataVersionNumber <= newAppVersion){

          let migrationData = require('../../migration_data').data["version"+this.dataVersionNumber];

          if(migrationData && this.groupNumber <= migrationData.totalGroups){

            this.fn_getVersionGroupInfo(migrationData.groups[this.groupNumber - 1].migrationId, versionGroupData => {
              
              if(!versionGroupData){

                this.fn_postMigrationData(migrationData.groups[this.groupNumber - 1].data, () => {

                  if(this.groupNumber == migrationData.totalGroups){
                    // // save version number to cache on complete groups posted of version
                    // localStorage.setItem('appversion', this.dataVersionNumber);
                    
                    this.dataVersionNumber++
                    // resetting group number
                    this.groupNumber = 1;
                    // check for next migration version if exist
                    this.fn_processMigrationData(newAppVersion, jtcd, isNotification);
                  }
                  else{
                    this.groupNumber++;
                    // check for next version group if exist
                    this.fn_processMigrationData(newAppVersion, jtcd, isNotification);
                  }

                });
              }
              else{
                this.groupNumber++;
                // check for next version group if exist
                this.fn_processMigrationData(newAppVersion, jtcd, isNotification);
              }
              
            });
          }
          else{
            this.dataVersionNumber++;
            // resetting group number
            this.groupNumber = 1;
            // check for next migration version if exist
            this.fn_processMigrationData(newAppVersion, jtcd, isNotification);
          }
        }
        else{
          this.fn_pageLoadComplete(newAppVersion, jtcd, isNotification);
        }
      },

      fn_pageLoadComplete: function(newAppVersion, jtcd, isNotification){
        console.log('pageloadcomplete');
        // save version number to cache
        localStorage.setItem('appversion', newAppVersion);  

        AndroidRoutingTest.onPageLoadCompleted('1', JSON.stringify({}));

        let postObj = {"eventName":"page_load_complete_main_app","eventData":[{"eventKey":"business_id","eventValue":this.$root.CurrentBusiness.BusinessID}]}
        this.$root.fn_postMetrics(postObj);

        console.log('notification ' + isNotification);
        if(JSON.parse(isNotification)){
          this.$root.fn_openNotification();
        }
        else if(Number(jtcd)){
          this.$root.fn_webRtcConnectionDetails();
        }
        else if(this.$root.CurrentBusiness.IsAccountantOnly){
          this.$router.replace('/settings');
        }
        else{
          this.fn_getSaleCount();
          // this.fn_checkTransactionCount();
          let bottomNavigationSet = Number(localStorage.getItem('bottomNavigationSet'));
          console.log(bottomNavigationSet);

          if(!bottomNavigationSet){
            this.fn_setBottomNavigation();
          }
          else{
            this.fn_showBottomNavigation();
          }

          // checking transaction count if data drive is not setup
          if(this.$root.CurrentBusiness && !this.$root.CurrentBusiness.DataDrive){
            setTimeout(() => {
              this.fn_checkTransactionCount();
            }, 300);
          }
          else{
            this.fn_checkNotificationPermissionStatus();
          }
        }

        let eventObj = {"eventName":"app_open_biz_registered","eventData":[{"eventKey":"business_name","eventValue":this.$root.CurrentBusiness.BusinessName}]}
        this.$root.fn_postMetrics(eventObj);


        // language preference event
        let langPreference = {
          eventName: 'language_preference',
          eventData: [
            {"eventKey":"app_language","eventValue":this.$root.selectedLanguage},
            {"eventKey":"print_language","eventValue":this.$root.invoicePrintInSelectedLanguage ? this.$root.selectedLanguage : 'en'},
            {"eventKey":"thermal_print_language","eventValue":this.$root.thermalPrintInSelectedLanguage ? this.$root.selectedLanguage : 'en'},
            {"eventKey":"business_id","eventValue":this.$root.CurrentBusiness.BusinessID},
          ]
        };
        this.$root.fn_postMetrics(langPreference, 'language');

        // getting thermal print settings
        this.$root.fn_getLocalItem('ThermalPrintSettings', response=>{
          let data = JSON.parse(response);
          if(data && data.LocalValue){
            this.$root.ThermalPrintSettings = JSON.parse(data.LocalValue);
            if(this.$root.ThermalPrintSettings && this.$root.ThermalPrintSettings.enableThermalPrint){
              this.$root.fn_openThermalView();
            }
          }
        });

        // getting thermal print settings
        this.$root.fn_getLocalItem('LabelPrintSettings', response=>{
          let data = JSON.parse(response);
          if(data && data.LocalValue){
            this.$root.LabelPrintSettings = JSON.parse(data.LocalValue);
          }
        });

        this.fn_removeMasterAndTransactions();

        // calling patch if running customer updated
        // setTimeout(() => {
        //   this.fn_checkRunningCustomer();
        // }, 500);
      },

      fn_getVersionGroupInfo: function(versionGroupMigrationId, callback){
        let self = this;
        this.getData('GroupVersionInfo', versionGroupMigrationId, 
          {
              onSuccess: function(response){
                console.log(response);
                callback ? callback(response) : '';
              }, 
              onError: function(error){
                console.log(error);
              }
          }
        );
      },

      fn_postMigrationData: function(dataObj, callback){

        this.postData('PostMigrationData', dataObj, 
          {
              onSuccess: function(response){
                console.log(response);
                callback ? callback() : '';
              }, 
              onError: function(error){
                console.log(error);
              }
          }
        );
      },

      // fn_checkPlayStoreUpdate : function(callback){
      //   console.log('checking play store update');
      //   let self = this;
      //   this.getData('CheckPlayStoreUpdate', null, 
      //     {
      //       onSuccess: function(response){
      //         console.log(response);
      //         let result = JSON.parse(response);
      //         self.$root.isAppUpdateAvailable = result ? true : false;
      //       }, 
      //       onError: function(error){
      //         console.log(error);
      //       }
      //     });
      // },

      // fn_checkTransactionCount: function(){
      //   this.showInvoiceCard = null;
      //   if(!localStorage.getItem('first_invoice_added')){
      //     let self = this;
      //     this.getData('TransactionCount', null, 
      //       {
      //         onSuccess: function(response){
      //             console.log(response);
      //             let count = Number(response);
      //             if(!count){
      //               // saving sample item for the first time user when no sale invoice is created
      //               if(!localStorage.getItem("demo_customer_item_added")){
      //                 self.fn_saveSampleItem();
      //               }
      //               else{
      //                 setTimeout(() => {
      //                   self.showInvoiceCard = true;
      //                 }, 300);
      //               }
      //             }
      //             else{
      //               self.showInvoiceCard = false;
      //               localStorage.setItem('first_invoice_added', 1);
      //             }
      //         }, 
      //         onError: function(error){
      //             console.log(error);
      //         }
      //     });
      //   }
      //   else{
      //     setTimeout(() => {
      //       this.showInvoiceCard = false;
      //     }, 300);
      //   } 
      // },

      fn_getSaleCount: function(){
        this.showInvoiceCard = null;
        if(!localStorage.getItem('first_invoice_added')){
          let filterObject = {};
          filterObject.type = 10003;
          filterObject.limit = 1;
          filterObject.startIndex = 0;
          filterObject.search = '';
          filterObject.startDate = this.$moment(this.$root.minDateSelection).startOf('day');
          filterObject.endDate = this.$moment(this.$root.maxDateSelection).endOf('day');
          filterObject.startDate = this.$root.fn_getLocalDateFormat(filterObject.startDate);
          filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);

          let self = this;
          this.getItems("AccountBookList", filterObject, 
            {
              onSuccess: function (response) {
                console.log(response);
                let responseJson = JSON.parse(response);
                if(Number(responseJson.totalCount) == 0){
                  // saving sample item for the first time user when no sale invoice is created
                  if(!localStorage.getItem("demo_customer_item_added")){
                    self.fn_saveSampleItem();
                  }
                  else{
                    setTimeout(() => {
                      self.showInvoiceCard = true;
                    }, 300);
                  }
                }
                else{
                  self.showInvoiceCard = false;
                  localStorage.setItem('first_invoice_added', 1);
                }
              },
              onError: function (error) {
                console.log(error);
              }
            }
          )
        }
        else{
          setTimeout(() => {
            this.showInvoiceCard = false;
          }, 300);
        }
		  },

      // saving only for first time
      fn_saveSampleItem: function(){
        let self = this;
        let postObj = {"name":"Sample Item","groupTypeId":101,"productCategoryId":null,"productCategoryName":null,"description":null,"productCode":null,"charges":null,"brandId":null,"brandName":null,"companyId":null,"companyName":null,"companyBarcode":null,"hsnCode":null,"unitId":"b4889cad-14d4-1679-e470-5789a48ce138","unitName":"Pcs","title":null,"sellingPrice":100,"mrp":null,"wholeSalePrice":null,"fixedCQty":null,"variant":{"description":null,"groupTypeId":401,"isDefault":false,"unitId":null,"productId":null,"productVariantId":null,"title":null,"variantBaseUnitId":null,"unitName":null,"packQuantity":null},"productVariants":[{"description":null,"groupTypeId":401,"isDefault":true,"productId":"8fed3f97-6f27-4efa-9f57-5c98f3dbe5ee","title":null,"productVariantId":"9bf5f381-e474-42cd-9f4d-997bdead4b7c","unitId":"b4889cad-14d4-1679-e470-5789a48ce138","unitName":"Pcs","packQuantity":null,"variantBaseUnitId":"b4889cad-14d4-1679-e470-5789a48ce138"}],"isSubVariant":false,"taxCategoryId":null,"taxCategoryName":null,"inventory":1,"isSystem":0,"draftItems":[],"createdDate":"2024-01-31T20:01:01.022Z","modifiedDate":"2024-01-31T20:01:01.022Z","isNew":true,"openingQty":null,"openingRate":null,"transactionId":null,"purchaseRate":null,"productId":"8fed3f97-6f27-4efa-9f57-5c98f3dbe5ee"};
				this.postData('Product', postObj, 
					{
						onSuccess: function(response){
              console.log(response);
              self.fn_saveDemoCustomer();
            },
            onError: function(error){
              console.log(error);
            }
					}
		    );
			},

      // saving only for first time
      fn_saveDemoCustomer: function(){
        let self = this;
        let postObj = {"accountId":"01486374-1366-4104-aa84-3111bbf2d950","title":null,"name":"Demo Customer","description":null,"groupTypeId":101,"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":104,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":0};
				this.postData('Ledger', postObj, 
					{
						onSuccess: function(response){
              console.log(response);
              localStorage.setItem('demo_customer_item_added', 1);
              self.showInvoiceCard = true;
            },
            onError: function(error){
              console.log(error);
            }
					}
		    );
      },

      fn_appDataShareStatus: function(){
        let self = this;
        this.getData("WatcherRunning", null, 
            {
                onSuccess: function(response){
                  console.log(response);
                  self.$refs['ref_favourites'].dataService = JSON.parse(response);
                }, 
                onError: function(error){
                  console.log(error);
                }
            }
        );
      },

      fn_checkTransactionCount: function(){
        let self = this;
        this.getData('TransactionCount', null, 
            {
                onSuccess: function(response){
                    console.log(response);
                    // let count = Number(response);
                    self.transactionCount = Number(response);
                    if((self.transactionCount && self.transactionCount>=3) || self.fn_differenceOfDays() > 7){
                      self.fn_openBackupAlertSheet();
                    }
                    // else{
                    //   if(!localStorage.getItem('diwali_greeting')){
                    //     this.fn_openGreeting();
                    //   }
                    // }
                }, 
                onError: function(error){
                    console.log(error);
                }
            }
        );
    },

    fn_checkNotificationPermissionStatus: function(){
        let self = this;
        this.getData('NotificationPermissionStatus', null, {
          onSuccess: function(response){
              console.log(response);
              if(!JSON.parse(response)){
                self.fn_openNotificationPermission();
              }
          }, 
          onError: function(error){
              console.log(error);
          }
      });
    },

    fn_openNotificationPermission: function(){
      let self = this;
      this.getData('CheckNotificationPermission', null, {
        onSuccess: function(response){
            console.log(response);
        }, 
        onError: function(error){
            console.log(error);
        }
      });
    },

    fn_checkDriveAccountLogin: function(){
      let self = this;
      this.getData("CheckDriveAccountLogin", null, 
      {
          onSuccess: function(response){
            console.log(response);
            if(self.$root.CurrentBusiness.DataDrive){
              if(!JSON.parse(response)){
                self.$root.CurrentBusiness.DataDrive = null;
                self.$root.fn_driveError('fromweb', 'User not login to drive');
                // self.fn_openBackupAlertSheet();
              }
              else{
                self.fn_checkDriveScopePermission();
              }
            }
          }, 
          onError: function(error){
            console.log(error);
          }
      });
    },

    fn_checkDriveScopePermission: function(){
      let self = this;
      this.getData("CheckDriveScopePermission", null, 
      {
          onSuccess: function(response){
            console.log(response);
            if(!JSON.parse(response)){
              self.confirmationHeader = "Allow Backup Permission";
              // self.confirmationMessage = "<div class='mb-2'>BizOps App need <span font-medium>Google</span> permission to backup your data on your <span font-medium>Google Drive</span></div><div>Please make sure to check highlighted </div>"
              self.confirmationMessage = "<div class='mb-2 font16'>Need <span font-medium>Google Drive</span> permission to backup your data</div><div class='font16'><ul><li>Press Okay</li><li>Check below highlighted permission</li><li>Then press Continue</li></ul></div>"
              self.okBtnText = 'Okay';
              self.cancelBtnText = 'Cancel';
              self.actionMethod = self.fn_getDriveScopePermission;
              self.fn_openDialogConfirmation();
            }
          }, 
          onError: function(error){
            console.log(error);
          }
      });
    },

    fn_getDriveScopePermission: function(){
      // let self = this;
      this.fn_closeDialogConfirmation();
      this.getData("GetDriveScopePermission", null, 
      {
          onSuccess: function(response){
            console.log(response);
          }, 
          onError: function(error){
            console.log(error);
          }
      });
    },

    fn_removeMasterAndTransactions: function(){
      if(this.$root.CurrentBusiness && this.$root.CurrentBusiness.BusinessID){
        console.log('inside');
        if(!this.$root.TransactionSettings.enableGodown){
          // removing godown from list if not enabled
          let godownIndex = this.$refs['ref_masters'].listCategories[1].items.findIndex(item=>{return item.title == 'Godowns'});
          if(godownIndex != -1){
            this.$refs['ref_masters'].listCategories[1].items.splice(godownIndex, 1);
          }

          let stockTransferIndex = this.$refs['ref_transactions'].listCategories[3].items.findIndex(item=>{return item.title == 'Stock Transfer'});
          if(stockTransferIndex != -1){
            this.$refs['ref_transactions'].listCategories[3].items.splice(stockTransferIndex, 1);
          }
        }

        if(!this.$root.TransactionSettings.enableBillMaterials){
          let billIndex = this.$refs['ref_transactions'].listCategories[3].items.findIndex(item=>{return item.title == 'Bill of Materials'});
          if(billIndex != -1){
            this.$refs['ref_transactions'].listCategories[3].items.splice(billIndex, 1);
          }
        }

        if(!this.$refs['ref_transactions'].listCategories[3].items.length){
          let listIndex = this.$refs['ref_transactions'].listCategories.findIndex(item=>{return item.name == 'Inventory'});
          if(listIndex != -1){
            this.$refs['ref_transactions'].listCategories.splice(listIndex, 1);
          }
        }
        
      }
    },

    fn_debug(){
      debugger;
      console.log('debug');
    }

    // fn_checkRunningCustomer: function(){
    //   let self = this;
    //   this.getData('Ledger', '2e87f316-d0bc-4880-83b6-f050e9ffa5da', 
    //   {
    //     onSuccess: function(response){
    //         console.log(response);
    //         let data = JSON.parse(response);
    //         if(!data || (data && data.name != 'Walk-in Customer')){
    //           self.fn_updateRunningCustomer();
    //         }
    //       },
    //       onError: function(error){
    //         console.log(error);
    //       }
    //   });
    // },

    // fn_updateRunningCustomer: function(){
    //   let dataObj = {"accountId":"2e87f316-d0bc-4880-83b6-f050e9ffa5da","title":null,"name":"Walk-in Customer","description":null,"groupTypeId":101,"accountGroupId":"e39f5778-d5c4-4812-a035-7924dd91156d","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":104,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1};
    //   this.postData('Ledger', dataObj, 
    //   {
    //     onSuccess: function(response){
    //         console.log(response);
    //       }, 
    //       onError: function(error){
    //         console.log(error);
    //       }
    //   });
    // }

    },
    mounted: function () {
        // alert(process.env.NODE_ENV);
      console.log('abc');
      actionTabConfigs.activeIndex === null ? actionTabConfigs.activeIndex = 0 : '';
      this.activeIndex = actionTabConfigs.activeIndex;
      this.fn_tabChange(this.activeIndex);
      this.fn_removeLocalStorage();
      this.fn_getSaleCount();

      // setTimeout(() => {
      //   this.hideBottomNavigation();
      // }, 2000);
      setTimeout(() => {
        this.fn_appDataShareStatus();
        this.fn_checkDriveAccountLogin();
      }, 500);
      // this.fn_checkTransactionCount();

      // if(actionTabConfigs.activeIndex != null){
      //   this.activeIndex = actionTabConfigs.activeIndex;
      //   this.fn_tabChange(this.activeIndex, true);
      // }

      window.js_globals.fn_onBackPress = this.exitApp;
      window.js_globals.fn_initActions = this.fn_initActions;
      window.js_globals.fn_checkIsWebViewLoaded = this.fn_checkIsWebViewLoaded;
      // window.js_globals.fn_showDataBackupAlert = this.fn_openDataBackupAlertSheet;
    },
    beforeRouteLeave(to, from, next){

      if(to.name!="reports" && to.name!="activitytabs" && to.name!="actions" && to.name!="notifications" && to.name!="settings"){
        this.fn_hideBottomNavigation();
      }
      next();
    },
    beforeRouteEnter(to, from, next){
      next(vm => {
        if(from.path!='/' && from.name!="reports" && from.name!="activitytabs" && from.name!="notifications" && from.name!="settings"){
          vm.fn_showWebView();
        }
        else{

        }

        // getting business details on load
        // this condition will run only once when app will start
        // if(!from.name && from.path=='/'){
        //     vm.$root.fn_getBusiness('actions');
        // }

        // let bottomNavigationSet = Number(localStorage.getItem('bottomNavigationSet'))
        // console.log(bottomNavigationSet);

        // if(!bottomNavigationSet){
        //   vm.fn_setBottomNavigation();
        // }
        // else{
        //   vm.fn_showBottomNavigation();
        // }
        let bottomNavigationSet = Number(localStorage.getItem('bottomNavigationSet'))
        console.log(bottomNavigationSet);

        if(!bottomNavigationSet){
          from.path!='/' ? vm.fn_setBottomNavigation() : '';
        }
        else{
          vm.fn_showBottomNavigation();
        }
        
    })
      // next(vm => {
      //     if(from.name!="reports" && from.name!="activitytabs" && from.name!="actions" && from.name!="notifications" && from.name!="settings"){
      //       vm.fn_showWebView();
      //     }

      //     vm.fn_showBottomNavigation();
      // })
    }
  }
</script>

<!-- <style>
  @page {

        margin-bottom: 40px;
        counter-increment: page;

        @bottom-right {
            border-top: 1px solid #000000;
            padding-right:20px;
            font-size: 12px !important;
            content: "Page " counter(page) " of " counter(pages);
        }
        @bottom-left {
            content: "Footer content goes here.";
            border-top: 1px solid #000000;
        }

    }
</style> -->

<!-- <style>
    .banner{
      width:100%;
      background:linear-gradient(90deg,#ff8a00,#ffd54a);
      color:#3b1f00;
      padding:14px 20px;
      text-align:center;
      font-weight:700;
      font-size:1.1rem;
      cursor:pointer;
      box-shadow:0 4px 10px rgba(0,0,0,0.1);
      z-index:1000;
      transition:transform 0.3s ease;
    }
    .banner:hover{transform:translateY(-2px);}

    .banner span{margin-left:8px;}
</style> -->


// WEBPACK FOOTER //
// src/components/actions/actions.vue